import $ from 'jquery'
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
import { stopAudio } from './sound'

class Modal {
  constructor() { }

  initialize() {
    this.class = ''
    this.$content = $('.js-modal-content')
    this.$closeBtn = $('.js-modal-close')
    this.$el = $('.js-modal')
    this.$el.on('click', () => {
      this.hide()
    })
    this.$closeBtn.on('click', () => {
      this.hide()
    })
    this.$content.on('click', (e) => {
      e.stopPropagation()
    })
    this.setModalBtnHandler()
  }

  show(html, className = '') {
    // 動画モーダルを開く前に再生中のボイスを止める（iOSマナーモードでの同時再生対策）
    stopAudio()
    this.$content.html(html)
    this.$el.fadeIn()
    this.additionalClass= className || ''
    this.$el.addClass(this.additionalClass)
    disableBodyScroll(document.querySelector('.js-modal-content'))
  }

  hide(){
    this.$el.fadeOut('normal', () => {
      this.$content.html('')
      clearAllBodyScrollLocks()
      this.$el.removeClass(this.additionalClass)
    })
  }

  setModalBtnHandler() {
    /* USAGE: <a class="js-modal-btn" data-modal-content-selector=".some-content-html" data-modal-class="modal-variant">hoge</a> */
    $('.js-modal-btn').on('click', (e) => {
      const $e = $(e.currentTarget)
      const selector = $e.attr('data-modal-content-selector')
      const className = $e.attr('data-modal-class')
      const html = $(selector).html()
      this.show(html, className)
      e.preventDefault()
      e.stopPropagation()
    })
    this.setYoutubeBtnHandler($('.js-youtube-modal'))
  }

  setYoutubeBtnHandler($el) {
    $el.on('click', (e) => {
      e.preventDefault()
      e.stopPropagation()
      const $e = $(e.currentTarget)
      const youtubeId = $e.attr('data-youtube-id')
      const vertical = $e.attr('data-youtube-vertical') === 'true'
      this.show(`
        <div class="youtube${vertical ? ' youtube-vertical' : ''}">
          <iframe width="560" height="315" src="https://www.youtube.com/embed/${youtubeId}?autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      `, vertical ? 'modal-youtube-vertical' : '')
    })
  }
}

export default new Modal()
